import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: "keyvalue"})
export class KeyValue implements PipeTransform {
  transform(value, args:string[]) : any {
    let keys = [];
    for (let key in value) {
      keys.push({key: key, value: value[key]});
    }
    return keys;
  }
}


/** WEBPACK FOOTER **
 ** ./TypeScripts/App/keyvalue.pipe.ts
 **/